export * from "./extractConsents";
